// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { QUOTE_LIST, SUBMIT_QUOTE, UPLOAD_PAYMENT_DETAILS } from '../../../../../common/constant'
import { get, post } from '../../../../../common/api'
import Api from '../../../../../common/api/multipart'

export const actionQuoteList = createAsyncThunk('quoteListStore/actionQuoteList', async (params, thunkAPI) => {
    return await post(QUOTE_LIST, params, thunkAPI)
})


// after choose plan on confirmation popup call this api in which selected plan will send in bE
export const actionQuoteSubmit = createAsyncThunk('quoteListStore/actionQuoteSubmit', async (params, thunkAPI) => {
    return await post(SUBMIT_QUOTE, params, thunkAPI)
})

// after uploading document on neft page of transtion on submit use this api 
export const actionUploadPaymentDetailsSubmit = createAsyncThunk('quoteListStore/actionUploadPaymentDetailsSubmit', async (params, thunkAPI) => {
  
    return await Api.multipart(UPLOAD_PAYMENT_DETAILS, params, thunkAPI)
})


export const quoteListSlice = createSlice({
    name: 'quoteListStore',

    initialState: {
        quoteList: null,
        loadingQuoteList: false,

        SubmitQuote: null,
        loadingSubmitQuoteList: false,

        SubmitPaymentDetails: null,
        loadingSubmitPaymentDetails: false,
    },

    reducers: {
        //reset or delete public store data
        resetQuoteList: (state) => {
            state.quoteList = null;
        },
        resetSubmitQuoteList: (state) => {
            state.SubmitQuote = null;
        },
        resetSubmitPaymentDetails: (state) => {
            state.SubmitPaymentDetails = null;
        }
     
    },
    extraReducers: builder => {
        builder
            //enquiry add
            .addCase(actionQuoteList.pending, (state) => {
                state.loadingQuoteList = true
            })
            .addCase(actionQuoteList.fulfilled, (state, action) => {
                state.loadingQuoteList = false
                state.quoteList = action.payload
            })
            .addCase(actionQuoteList.rejected, (state) => {
                state.loadingQuoteList = false
            })

            //QUOTE SYBMUIT
            .addCase(actionQuoteSubmit.pending, (state) => {
                state.loadingSubmitQuoteList = true
            })
            .addCase(actionQuoteSubmit.fulfilled, (state, action) => {
                state.loadingSubmitQuoteList = false
                state.SubmitQuote = action.payload;
            })
            .addCase(actionQuoteSubmit.rejected, (state, action) => {
                state.loadingSubmitQuoteList = false
                state.SubmitQuote = { status: false, message: action.payload };
            })

            // PAYMENT DETAILS SUBMIT
            .addCase(actionUploadPaymentDetailsSubmit.pending, (state) => {
                state.loadingSubmitPaymentDetails = true
            })
            .addCase(actionUploadPaymentDetailsSubmit.fulfilled, (state, action) => {
                state.loadingSubmitPaymentDetails = false
                state.SubmitPaymentDetails = action.payload
            })
            .addCase(actionUploadPaymentDetailsSubmit.rejected, (state, action) => {
                state.loadingSubmitPaymentDetails = false
                state.SubmitPaymentDetails = { status: false, message: action.payload };
            })
 
    }
})
export const { resetQuoteList, resetSubmitQuoteList, resetSubmitPaymentDetails} = quoteListSlice.actions

export default quoteListSlice.reducer